let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let CreatorRating = require("./moderation-creator-rating");

class ModerationUploadInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    getNoteStatus() {
        let noteStatus;

        if (this.props.upload.creator.important_note) {
            noteStatus = "red";
        } else {
            noteStatus = "yellow";
        }

        return noteStatus;
    }

    render() {
        let creator = this.props.upload.creator,
            icons = this.props.icons,
            remainingIcons = this.props.upload.icon_count,
            noteStatusColor = this.getNoteStatus();

        return (
            <span>
                <section className={`creator_info row`}>
                    <div className="navbar_header col-xs-3 row">
                        <a
                            href={`/fort/members/${creator.id}/`}
                            target="_blank"
                            className="profile avatar col-xs-3"
                        >
                            <div
                                style={{
                                    backgroundImage: `url(${creator.avatar})`,
                                    borderRadius: "50%",
                                    width: "40px",
                                    height: "40px",
                                    backgroundSize: "40px"
                                }}
                            />
                        </a>
                        <div className="creator-info col-xs-9">
                            <div className="creator-name">{creator.name}</div>
                            <div className="creator-email gray">
                                {creator.email}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-9 row">
                        <div className="rating col-xs-3">
                            <span className="gray">Rating</span>
                            <CreatorRating
                                starRating={creator.star_rating}
                                iconRating={creator.icon_rating}
                            />
                        </div>
                        <div className="uploads col-xs-3">
                            <span className="gray">Icons Remaining</span>
                            <input
                                type="text"
                                value={remainingIcons}
                                className="btn btn-default icons-remaining"
                                readOnly
                            />
                        </div>
                        <div className="col-xs-6 creator-actions">
                            <button
                                className={`ui_notes ${noteStatusColor}`}
                                onClick={this.viewNote.bind(this)}
                            >
                                Notes
                            </button>
                            <button
                                className="ui_clock purple"
                                onClick={this.saveForLater.bind(this)}
                            >
                                Save
                            </button>
                            <button
                                className="ui_flag red"
                                onClick={this.suspendCreator.bind(this)}
                            >
                                Suspend
                            </button>
                            <a
                                href={`/fort/members/${creator.id}/`}
                                className="text-link"
                                target="_blank"
                            >
                                View History
                            </a>
                        </div>
                    </div>
                </section>
            </span>
        );
    }

    saveForLater() {
        this.props.showModal(null, "SAVE_FOR_LATER", {
            upload: this.props.upload
        });
    }

    suspendCreator() {
        this.props.showModal(null, "SUSPEND_CREATOR", {
            creator: this.props.upload.creator,
            referringComponent: "Moderation"
        });
    }

    viewNote() {
        this.props.showModal(null, "VIEW_NOTES", { upload: this.props.upload });
    }
}

module.exports = connect(null, {
    showModal: actions.showModal
})(ModerationUploadInfo);
